export type SpaceAccountPostHogFeatureFlagIds =
  | "theme-switcher"
  | "image-viewer"
  | "heads-up-live"
  | "huddle-mode"
  | "content-understanding"
  | "pdf-paywall"
  | "mem-agent";

export enum SpaceAccountPostHogFeatureFlagChatZeroStateVariant {
  AskAboutYourNotes = "ask_about_your_notes_001",
  Onboarding = "onboarding_001",
}
